import { ReactNode } from "react";

export enum ChangeOrderCSTab {
  header = "header",
  itemDetails = "itemDetails",
  addNewItem = "addNewItem"
}

export enum ViewEditMode {
  VIEW = "VIEW",
  EDIT = "EDIT",
  ADD = "ADD"
}

export interface ModalConfirmDeleteProps {
  title?: string | ReactNode;
  content?: string | ReactNode;
  okText?: string;
  cancelText?: string;
  typeConfirm?: typeConfirmDelete;
  valueSelect?: string;
}

export enum typeConfirmDelete {
  cancelOrder = "cancelOrder",
  cancelOrderLine = "cancelOrderLine"
}

export enum TypeOfAddProd {
  Successfully = "success",
  UnSuccessfully = "error"
}

export enum TypeConfirm {
  SUBMIT = "submit",
  CANCEL = "cancel",
  REVERT = "revert"
}

export enum TypeSubmit {
  SUBMIT_HEADER = 1,
  SUBMIT_MATERIAL = 2
}

export enum ContentHeaderTab {
  partner = "partner",
  additionalData = "additionalData",
  sales = "sales"
}

export enum ItemTab {
  tabA = "tabA",
  tabB = "tabB",
  tabC = "tabC",
  tabD = "tabD"
}

export interface ModalWarningProbs {
  title?: string | ReactNode;
  okText?: string;
}

export enum ErrorFields {
  CHECKOUT_OUTDATED_ERROR = "ข้อมูลคำสั่งซื้อมีการเปลี่ยนแปลง กดปุ่มตกลง เพื่อแสดงข้อมูลปัจจุบัน"
}
